import { useEffect, useState, useCallback } from "react"
import { useNavigate } from "react-router-dom";
import useErroPadrao from '../../../hooks/useErroPadrao';
import useHelp from '../../../hooks/useHelp';
import { CHAVE_TOKEN } from "../../../utils/formata";
import InvestimentoFunil from "./InvestimentoFunil";
import EnviarGrupos from "./EnviarGrupos";
import FunilPerguntas from "./FunilPerguntas";

const TIPOS = [
    { valor: "produto", rotulo: "Produto", cor: "#2ecc71" },
    { valor: "servico", rotulo: "Serviço", cor: "#3498db" },
    { valor: "oferta", rotulo: "Oferta", cor: "#d4af37" },
    { valor: "faq", rotulo: "Dúvida frequente", cor: "#9b59b6" },
    { valor: "regra", rotulo: "Regra do negócio", cor: "#e67e22" },
    { valor: "politica", rotulo: "Política", cor: "#95a5a6" },
];

const corDoTipo = (t) => TIPOS.find((x) => x.valor === t)?.cor || "#9aa5b5";
const rotuloDoTipo = (t) => TIPOS.find((x) => x.valor === t)?.rotulo || t;

export default function AtendimentoIA() {
    // aba aberta fica guardada (regra da Dani: persistir aba ativa no localStorage)
    // ?grupos=<telefone> vem do botão "Enviar pra grupos" do cadastro do cliente: abre direto nessa aba
    const [aba, setAbaEstado] = useState(() => { if (new URLSearchParams(window.location.search).has("grupos")) return "grupos"; try { return localStorage.getItem("atendimento-aba") || "cerebro"; } catch { return "cerebro"; } });
    const setAba = (k) => { setAbaEstado(k); try { localStorage.setItem("atendimento-aba", k); } catch {} };
    const [itens, setItens] = useState([]);
    const [config, setConfig] = useState(null);
    const [editando, setEditando] = useState(null);
    const [busca, setBusca] = useState("");
    const [filtro, setFiltro] = useState("todos");
    const [carregando, setCarregando] = useState(true);
    const [salvando, setSalvando] = useState(false);
    const [robo, setRobo] = useState(null);
    const [trocandoModo, setTrocandoModo] = useState(false);
    const { consultarConhecimento, salvarConhecimento, removerConhecimento, consultarConfigIa, salvarConfigIa, statusRobo, escolherModoRobo } = useHelp();
    const { setErroPadrao } = useErroPadrao();
    const navigate = useNavigate();

    // O QR do WhatsApp vive ~20s. Só vale a pena ficar buscando enquanto a aba de
    // conexão está aberta — em outra aba isso seria bater na API à toa.
    useEffect(() => {
        if (aba !== "conexao") return;
        let vivo = true;
        const buscar = () => statusRobo().then((r) => { if (vivo) setRobo(r); }).catch(() => {});
        buscar();
        const t = setInterval(buscar, 3000);
        return () => { vivo = false; clearInterval(t); };
    }, [aba, statusRobo]);

    const carregar = useCallback(() => {
        setCarregando(true);
        Promise.all([consultarConhecimento(), consultarConfigIa()])
            .then(([lista, cfg]) => { setItens(lista || []); setConfig(cfg); })
            .catch((error) => setErroPadrao(error))
            .finally(() => setCarregando(false));
    }, [consultarConhecimento, consultarConfigIa, setErroPadrao]);

    useEffect(() => {
        if (!localStorage.getItem(CHAVE_TOKEN)) {
            navigate("/login");
            return;
        }
        carregar();
    }, [carregar, navigate]);

    function handleSalvarItem(e) {
        e.preventDefault();
        setSalvando(true);
        salvarConhecimento(editando)
            .then(() => { setEditando(null); carregar(); })
            .catch((error) => setErroPadrao(error))
            .finally(() => setSalvando(false));
    }

    function handleExcluir(item) {
        if (!window.confirm(`Remover "${item.titulo}" do cérebro da IA?`)) return;
        removerConhecimento(item.id).then(carregar).catch((error) => setErroPadrao(error));
    }

    function handleSalvarConfig(e) {
        e.preventDefault();
        setSalvando(true);
        salvarConfigIa(config)
            .then(carregar)
            .catch((error) => setErroPadrao(error))
            .finally(() => setSalvando(false));
    }

    const visiveis = itens.filter((i) => {
        const casaBusca = !busca || (i.titulo + i.conteudo).toLowerCase().includes(busca.toLowerCase());
        const casaFiltro = filtro === "todos" || i.tipo === filtro;
        return casaBusca && casaFiltro;
    });

    const contagem = (tipo) => itens.filter((i) => i.tipo === tipo).length;

    return (
        <div className="pagina">
            <div className="cabecalho-pagina">
                <div style={{minWidth: 0}}>
                    <h2 className="he-titulo">Atendimento <span className="he-dourado">com IA</span></h2>
                    <p style={{color: "#9aa5b5", fontSize: "0.9em", margin: 0}}>
                        Ensine a IA sobre o negócio — ela atende seus clientes no WhatsApp 24h
                    </p>
                </div>
                {config &&
                    <div className="he-card resumo-topo" style={{padding: "0.8em 1em"}}>
                        <span style={{display: "flex", alignItems: "center", gap: 10, minWidth: 0}}>
                            <span style={{
                                width: 10, height: 10, borderRadius: "50%", flexShrink: 0,
                                background: config.iaAtiva ? "#2ecc71" : "#6b7280",
                                boxShadow: config.iaAtiva ? "0 0 10px #2ecc71" : "none",
                            }}></span>
                            <span style={{fontWeight: 700, color: config.iaAtiva ? "#2ecc71" : "#9aa5b5"}}>
                                {config.iaAtiva ? "IA ATIVA" : "IA desligada"}
                            </span>
                        </span>
                        <button
                            className={`btn btn-sm ${config.iaAtiva ? "btn-outline-danger" : "btn-he"}`}
                            style={{flexShrink: 0, whiteSpace: "nowrap"}}
                            onClick={() => salvarConfigIa({...config, iaAtiva: !config.iaAtiva}).then(carregar).catch(setErroPadrao)}
                        >
                            {config.iaAtiva ? "Desligar" : "Ligar IA"}
                        </button>
                    </div>
                }
            </div>

            {/* Abas */}
            <div className="filtros-status" style={{margin: "1.2em 0"}}>
                {[["cerebro", "bi-lightbulb", "Cérebro da IA"], ["config", "bi-sliders", "Personalidade & Regras"], ["conexao", "bi-qr-code", "Conexão do robô"], ["funil", "bi-graph-up-arrow", "Investimento"], ["grupos", "bi-send", "Enviar pra grupos"], ["perguntas", "bi-list-ol", "Funil de perguntas"]].map(([k, ic, txt]) => (
                    <button key={k} className={`btn btn-sm ${aba === k ? "btn-he" : "btn-outline-he"}`} onClick={() => setAba(k)}>
                        <i className={`bi ${ic}`}></i> {txt}
                        {k === "conexao" && robo && !robo.conectado &&
                            <span style={{
                                marginLeft: 6, width: 8, height: 8, borderRadius: "50%",
                                display: "inline-block", background: "#e74c3c", boxShadow: "0 0 8px #e74c3c",
                            }}></span>
                        }
                    </button>
                ))}
            </div>

            {carregando ? <div style={{textAlign: "center", padding: "3em"}}><span className="spinner-border" style={{color: "#d4af37"}}></span></div> :

            aba === "funil" ? <InvestimentoFunil /> :

            aba === "grupos" ? <EnviarGrupos /> :

            aba === "perguntas" ? <FunilPerguntas /> :

            aba === "conexao" ? (
                <div className="he-card" style={{textAlign: "center", padding: "1.6em"}}>
                    <div style={{display: "flex", gap: 10, alignItems: "center", justifyContent: "center", marginBottom: 6}}>
                        <span style={{
                            width: 12, height: 12, borderRadius: "50%",
                            background: robo?.conectado ? "#2ecc71" : (robo?.vivo ? "#e0a800" : "#e74c3c"),
                            boxShadow: `0 0 10px ${robo?.conectado ? "#2ecc71" : (robo?.vivo ? "#e0a800" : "#e74c3c")}`,
                        }}></span>
                        <strong style={{fontSize: "1.05rem", color: robo?.conectado ? "#2ecc71" : (robo?.vivo ? "#e0a800" : "#e74c3c")}}>
                            {robo?.conectado ? "WhatsApp conectado" : (robo?.vivo ? "Robô ligado, sem WhatsApp" : "Robô desligado")}
                        </strong>
                    </div>

                    {robo?.conectado ? <>
                        <p style={{color: "#9aa5b5", margin: "0 0 4px"}}>
                            Atendendo pelo número <strong className="he-dourado">{robo.numero || "—"}</strong>.
                        </p>
                        <p style={{color: "#9aa5b5", fontSize: "0.86rem", margin: 0}}>
                            Está tudo certo. O QR só aparece aqui quando a conexão cair.
                        </p>
                    </> : <>
                        <div style={{display: "flex", gap: 6, justifyContent: "center", margin: "14px 0 18px", flexWrap: "wrap"}}>
                            {[["qr", "bi-qr-code", "Escanear QR"], ["codigo", "bi-123", "Código de 8 letras"]].map(([v, ic, txt]) => (
                                <button key={v} className={`btn btn-sm ${(robo?.modoConexao || "qr") === v ? "btn-he" : "btn-outline-he"}`}
                                    disabled={trocandoModo}
                                    onClick={() => {
                                        setTrocandoModo(true);
                                        setRobo((r) => ({...r, modoConexao: v, qrImagem: null, codigo: null}));
                                        escolherModoRobo(v).catch(setErroPadrao).finally(() => setTrocandoModo(false));
                                    }}>
                                    <i className={`bi ${ic}`}></i> {txt}
                                </button>
                            ))}
                        </div>

                        {(robo?.modoConexao || "qr") === "codigo" ? (
                            robo?.codigo ? <>
                                <p style={{color: "#9aa5b5", margin: "0 0 12px"}}>
                                    Digita este código no WhatsApp da Help:
                                </p>
                                <div style={{
                                    display: "inline-block", background: "#ffffff0d", border: "1px solid #d4af3755",
                                    borderRadius: 14, padding: "16px 26px", fontSize: "2rem", fontWeight: 800,
                                    letterSpacing: "0.28em", color: "#d4af37", fontFamily: "monospace",
                                }}>{robo.codigo}</div>
                                <ol style={{textAlign: "left", color: "#c9d3e0", fontSize: "0.9rem", maxWidth: 400, margin: "18px auto 0", paddingLeft: 20}}>
                                    <li>WhatsApp da Help &rsaquo; menu ⋮ &rsaquo; <strong>Aparelhos conectados</strong></li>
                                    <li><strong>Conectar um aparelho</strong></li>
                                    <li>Toca em <strong>Conectar com número de telefone</strong></li>
                                    <li>Digita o código acima</li>
                                </ol>
                                <p style={{color: "#6b7683", fontSize: "0.8rem", marginTop: 12}}>
                                    Serve pra reconectar direto do celular, sem precisar de outra tela.
                                </p>
                            </> : <>
                                <p style={{color: "#9aa5b5", margin: "10px 0 0"}}>
                                    Gerando o código… pode levar até 3 minutos entre uma tentativa e outra.
                                </p>
                                <div style={{marginTop: 14}}><span className="spinner-border" style={{color: "#d4af37"}}></span></div>
                            </>
                        ) : robo?.qrImagem ? <>
                            <p style={{color: "#9aa5b5", margin: "0 0 14px"}}>
                                Escaneia com o WhatsApp da Help. O código troca sozinho a cada 20 segundos.
                            </p>
                            <div style={{background: "#fff", borderRadius: 14, padding: 14, display: "inline-block"}}>
                                <img src={robo.qrImagem} alt="QR do WhatsApp" style={{display: "block", width: 280, height: 280}}/>
                            </div>
                            <ol style={{textAlign: "left", color: "#c9d3e0", fontSize: "0.9rem", maxWidth: 380, margin: "18px auto 0", paddingLeft: 20}}>
                                <li>Abre o WhatsApp da Help no celular</li>
                                <li>Menu ⋮ &rsaquo; <strong>Aparelhos conectados</strong></li>
                                <li><strong>Conectar um aparelho</strong></li>
                                <li>Aponta a câmera pro quadrado acima</li>
                            </ol>
                        </> : <>
                        <p style={{color: "#9aa5b5", margin: "10px 0 0"}}>
                            {robo?.vivo
                                ? "O robô está tentando gerar um código novo. Aguarda uns segundos aqui mesmo."
                                : "O robô não está rodando no computador. Abre o atalho do robô e volta nesta tela."}
                        </p>
                        <div style={{marginTop: 14}}><span className="spinner-border" style={{color: "#d4af37"}}></span></div>
                    </>}
                    </>}

                    {robo?.visto &&
                        <p style={{color: "#6b7683", fontSize: "0.78rem", marginTop: 18, marginBottom: 0}}>
                            Último sinal do robô: {new Date(robo.visto).toLocaleString("pt-BR")}
                        </p>
                    }
                </div>
            ) :

            aba === "cerebro" ? <>
                {/* Barra de ações */}
                <div style={{display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginBottom: "1em"}}>
                    <button className="btn btn-he btn-total-mobile" onClick={() => setEditando({ tipo: "produto", ativo: true })}>
                        <i className="bi bi-plus-lg"></i> Ensinar algo novo à IA
                    </button>
                    <input
                        className="form-control"
                        style={{width: "100%", maxWidth: 320}}
                        placeholder="Buscar no que a IA sabe..."
                        value={busca}
                        onChange={(e) => setBusca(e.target.value)}
                    />
                    <span style={{marginLeft: "auto", color: "#9aa5b5", fontSize: "0.9em"}}>
                        {visiveis.length} de {itens.length} itens
                    </span>
                </div>

                {/* Filtros */}
                <div className="filtros-status" style={{marginBottom: "1.2em"}}>
                    <button className={`btn btn-sm ${filtro === "todos" ? "btn-he" : "btn-outline-he"}`} onClick={() => setFiltro("todos")}>
                        Todos ({itens.length})
                    </button>
                    {TIPOS.filter((t) => contagem(t.valor) > 0).map((t) => (
                        <button key={t.valor} className={`btn btn-sm ${filtro === t.valor ? "btn-he" : "btn-outline-he"}`} onClick={() => setFiltro(t.valor)}>
                            {t.rotulo} ({contagem(t.valor)})
                        </button>
                    ))}
                </div>

                {/* Formulário */}
                {editando &&
                    <form onSubmit={handleSalvarItem} className="he-card form-mobile" style={{border: "1px solid #d4af37", marginBottom: "1.2em"}}>
                        <h5 className="he-titulo he-dourado" style={{marginBottom: "0.7em"}}>
                            <i className="bi bi-lightbulb"></i> {editando.id ? "Editar" : "Ensinar algo novo"}
                        </h5>
                        <div className="row">
                            <div className="col-md-5 campo-form">
                                <label className="form-label" style={{fontSize: "0.8em"}}>Título</label>
                                <input className="form-control form-control-sm" placeholder="Ex: Crédito de R$ 1.000"
                                    value={editando.titulo || ""} onChange={(e) => setEditando({...editando, titulo: e.target.value})} required/>
                            </div>
                            <div className="col-md-4 campo-form">
                                <label className="form-label" style={{fontSize: "0.8em"}}>Preço / condição (opcional)</label>
                                <input className="form-control form-control-sm" placeholder="20x R$ 60/dia ou 24x R$ 50/dia"
                                    value={editando.preco || ""} onChange={(e) => setEditando({...editando, preco: e.target.value})}/>
                            </div>
                            <div className="col-md-3 campo-form">
                                <label className="form-label" style={{fontSize: "0.8em"}}>Tipo</label>
                                <select className="form-select form-select-sm" value={editando.tipo}
                                    onChange={(e) => setEditando({...editando, tipo: e.target.value})}>
                                    {TIPOS.map((t) => <option key={t.valor} value={t.valor}>{t.rotulo}</option>)}
                                </select>
                            </div>
                            <div className="col-12 campo-form">
                                <label className="form-label" style={{fontSize: "0.8em"}}>Tudo que a IA precisa saber</label>
                                <textarea className="form-control form-control-sm" rows={6}
                                    placeholder="Escreva como se estivesse explicando pra uma funcionária nova..."
                                    value={editando.conteudo || ""} onChange={(e) => setEditando({...editando, conteudo: e.target.value})} required/>
                            </div>
                        </div>
                        <div className="acoes-linha uma-coluna" style={{marginTop: 12}}>
                            <button type="submit" className="btn btn-he" disabled={salvando}>
                                {salvando ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-check-lg"></i> Adicionar ao cérebro</>}
                            </button>
                            <button type="button" className="btn btn-outline-he" onClick={() => setEditando(null)}>Cancelar</button>
                        </div>
                    </form>
                }

                {/* Cards */}
                <div style={{display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(min(280px, 100%), 1fr))", gap: "1em"}}>
                    {visiveis.map((item) => (
                        <div key={item.id} className="he-card" style={{display: "flex", flexDirection: "column", gap: 8, minWidth: 0}}>
                            <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8, flexWrap: "wrap"}}>
                                <span style={{
                                    background: corDoTipo(item.tipo) + "22",
                                    color: corDoTipo(item.tipo),
                                    border: `1px solid ${corDoTipo(item.tipo)}55`,
                                    borderRadius: 20, padding: "2px 10px", fontSize: "0.7em", fontWeight: 700,
                                }}>
                                    {rotuloDoTipo(item.tipo)}
                                </span>
                                {item.preco && <span className="he-dourado" style={{fontSize: "0.78em", fontWeight: 700, textAlign: "right", overflowWrap: "break-word", minWidth: 0}}>{item.preco}</span>}
                            </div>
                            <div style={{fontWeight: 700, fontSize: "1.05em", overflowWrap: "break-word"}}>{item.titulo}</div>
                            <div style={{color: "#9aa5b5", fontSize: "0.85em", lineHeight: 1.55, flex: 1, overflowWrap: "break-word"}}>
                                {item.conteudo.length > 150 ? item.conteudo.slice(0, 150) + "..." : item.conteudo}
                            </div>
                            <div className="acoes-linha">
                                <button className="btn btn-sm btn-outline-he" style={{flex: 1}} onClick={() => setEditando(item)}>
                                    <i className="bi bi-pencil"></i> Editar
                                </button>
                                <button className="btn btn-sm btn-outline-danger" onClick={() => handleExcluir(item)}>
                                    <i className="bi bi-trash"></i><span className="so-mobile-inline"> Excluir</span>
                                </button>
                            </div>
                        </div>
                    ))}
                    {visiveis.length === 0 &&
                        <div className="he-card" style={{gridColumn: "1/-1", textAlign: "center", color: "#9aa5b5", padding: "2em"}}>
                            Nada por aqui ainda. Clique em <strong className="he-dourado">Ensinar algo novo à IA</strong> pra começar.
                        </div>
                    }
                </div>
            </> :

            /* Aba de configuração */
            config &&
                <form onSubmit={handleSalvarConfig} className="form-mobile">
                    <div className="he-card" style={{marginBottom: "1em"}}>
                        <h5 className="he-titulo he-dourado"><i className="bi bi-chat-heart"></i> Primeira mensagem</h5>
                        <p style={{color: "#9aa5b5", fontSize: "0.85em"}}>O que a IA responde quando alguém chama pela primeira vez</p>
                        <textarea className="form-control" rows={4} value={config.boasVindas || ""}
                            onChange={(e) => setConfig({...config, boasVindas: e.target.value})}/>
                    </div>

                    <div className="he-card" style={{marginBottom: "1em"}}>
                        <h5 className="he-titulo he-dourado"><i className="bi bi-person-heart"></i> Personalidade</h5>
                        <p style={{color: "#9aa5b5", fontSize: "0.85em"}}>Como ela fala: tom, tamanho das mensagens, jeito</p>
                        <textarea className="form-control" rows={4} value={config.personalidade || ""}
                            onChange={(e) => setConfig({...config, personalidade: e.target.value})}/>
                    </div>

                    <div className="he-card" style={{marginBottom: "1em"}}>
                        <h5 className="he-titulo" style={{color: "#ff6b5b"}}><i className="bi bi-shield-exclamation"></i> Regras — o que ela NUNCA pode fazer</h5>
                        <textarea className="form-control" rows={6} value={config.regras || ""}
                            onChange={(e) => setConfig({...config, regras: e.target.value})}/>
                    </div>

                    <div className="he-card" style={{marginBottom: "1em"}}>
                        <h5 className="he-titulo he-dourado"><i className="bi bi-building"></i> Sobre o negócio</h5>
                        <textarea className="form-control" rows={4} value={config.sobreNegocio || ""}
                            onChange={(e) => setConfig({...config, sobreNegocio: e.target.value})}/>
                    </div>

                    <div className="he-card" style={{marginBottom: "1em"}}>
                        <h5 className="he-titulo he-dourado"><i className="bi bi-clock"></i> Horário de atendimento</h5>
                        <div style={{display: "flex", gap: 12, flexWrap: "wrap"}}>
                            <div style={{flex: "0 1 170px", minWidth: 0}}>
                                <label className="form-label" style={{fontSize: "0.8em"}}>Começa às</label>
                                <input className="form-control form-control-sm" type="time" value={config.horarioInicio || "08:00"}
                                    onChange={(e) => setConfig({...config, horarioInicio: e.target.value})}/>
                            </div>
                            <div style={{flex: "0 1 170px", minWidth: 0}}>
                                <label className="form-label" style={{fontSize: "0.8em"}}>Até às</label>
                                <input className="form-control form-control-sm" type="time" value={config.horarioFim || "21:00"}
                                    onChange={(e) => setConfig({...config, horarioFim: e.target.value})}/>
                            </div>
                        </div>
                    </div>

                    <button type="submit" className="btn btn-he" style={{width: "100%"}} disabled={salvando}>
                        {salvando ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-check-lg"></i> SALVAR TUDO</>}
                    </button>
                </form>
            }
        </div>
    )
}
